import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../../../FeaturedTable/FeaturedTable'
import { columns } from '../../helpers'

const GiftCardsList = ({
  isLoading,
  data,
  onSelectCard = (_card) => {},
  onSendEmail = (_rewardId) => {},
  building,
}) => {
  const { t } = useTranslation(['rewards-dashboard', 'rewards-gift', 'rewards-table'])
  return (
    <div className={`ctp-gift-cards-list ${!isLoading ? '' : 'is-loading'}`}>
      {!isLoading && (
        <React.Fragment>
          {data.length > 0 && building ? (
            <FeaturedTable
              columns={columns({
                onShowDetails: onSelectCard,
                onSendEmail,
                timezone: building.timezone,
                t,
              })}
              onRowClick={onSelectCard}
              data={data}
            />
          ) : (
            t('rewards-dashboard:leaderBoard.noResultsYet')
          )}
        </React.Fragment>
      )}
    </div>
  )
}

GiftCardsList.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.array,
  onSelectCard: PropTypes.func,
  onSendEmail: PropTypes.func,
  building: PropTypes.object,
}

export default GiftCardsList
